import React from 'react';
import {appText} from '../../../assets/text/appText';
import styles from './PasswordValidator.module.css';

export const isPasswordValid = (password: string) => {
  const text = password.trim();
  return (
    isValidLength(text) &&
    isValidLetterNumber(text) &&
    isValidUpperLower(text) &&
    isValidSpecialCharacter(text)
  );
};

const isValidLength = (v: string) => v.length >= 8;

const isValidLetterNumber = (v: string) =>
  /\d[a-zA-Z]|[a-zA-Z]\d|\d[~,`,!,@,#,$,%,^,&,*,(,),_,-,+,=,{,[,},\],|,\\,:,;,",',<,>,.,?,/]|[~,`,!,@,#,$,%,^,&,*,(,),_,-,+,=,{,[,},\],|,\\,:,;,",',<,>,.,?,/]\d/i.test(
    v,
  );

const isValidUpperLower = (v: string) => /[A-Z]/.test(v) && /[a-z]/.test(v);

const isValidSpecialCharacter = (v: string) =>
  /[~,`,!,@,#,$,%,^,&,*,(,),_,-,+,=,{,[,},\],|,\\,:,;,",',<,>,.,?,/]/i.test(v);

/////////////////////////////////

interface Props {
  value: string;
  className?: string;
}
const PasswordValidator = React.memo(({value, className}: Props) => {
  const renderValidationSection = (title: string, isValid: boolean) => (
    <div className={styles.section}>
      <div className={styles.outer}>
        {isValid && <div className={styles.inner} />}
      </div>
      <p className={styles.text}>{title}</p>
    </div>
  );

  return (
    <div className={`${className ? className : ''}`}>
      <p className={styles.label}>{appText.passwordMustContain}</p>
      <div>
        {renderValidationSection(
          appText.passwordValidationLength,
          isValidLength(value),
        )}
        {renderValidationSection(
          appText.passwordValidationNumber,
          isValidLetterNumber(value),
        )}
        {renderValidationSection(
          appText.passwordValidationCase,
          isValidUpperLower(value),
        )}
        {renderValidationSection(
          appText.passwordValidationCharacter,
          isValidSpecialCharacter(value),
        )}
      </div>
    </div>
  );
});

export default PasswordValidator;
